
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../constants";

export const fetchUser = createAsyncThunk(
  "users/fetchByEmail",
  async (creds, thunkAPI) => {
    try {
      const response = await axios.post(`${API_URL}/login`, creds);
      return response.data;
    } catch (e) {
      console.log(e);
      return thunkAPI.rejectWithValue(e.response?.data || e.message);
    }
  }
);

export const checkExamCode = createAsyncThunk(
  "users/checkExamCode",
  async (code, thunkAPI) => {
    try {
      const response = await axios.post(`${API_URL}/checkexamcode`, code);
      return response.data;
    } catch (e) {
      console.log(e);
      return thunkAPI.rejectWithValue(e.response?.data || e.message);
    }
  }
);

const initialState = {
  user: {},
  token: "",
  exams: {},
  examSession: {},
  error: null,
  examVerified: false,
  loading: false,
  isLoggedIn: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logoutUser: (state) => {
      state.user = {};
      state.token = "";
      state.isLoggedIn = false;
      state.userExams = {};
      state.exams = {};
      state.examVerified = false;
    },
    clearExamVerified: (state) => {
      state.examVerified = false;
      state.exams = {};
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => 
    { builder .addCase(checkExamCode.pending, (state) => { state.examLoading = true; state.error = null; })
    .addCase(checkExamCode.fulfilled, (state, action) => { state.examLoading = false; state.examVerified = true; state.exams = action.payload; })
    .addCase(checkExamCode.rejected, (state, action) => { state.examLoading = false; state.error = action.error.message; }) 
    .addCase(fetchUser.pending, (state) => { state.loading = true; state.error = null; }) 
    .addCase(fetchUser.fulfilled, (state, action) => 
      { console.log('Action from User Slice: ', action); 
        state.loading = false; 
        state.isLoggedIn = true; 
        state.user = action.payload.user; 
        state.token = action.payload.token; 
        state.exams = action.payload.exams; 
        state.examVerified = false; }) 
        .addCase(fetchUser.rejected, (state, action) => 
          { state.loading = false; state.error = action.error.message; }); },
});

// example of exporting a standard synchronous action
export const { logoutUser, clearExamVerified, clearError } = userSlice.actions;

export default userSlice.reducer;
